eventBus.on('variant:change', (event) => {
  let firstVariantImageDesktop = document.querySelector('#productMediaDesktop [data-attached-to-first-variant]');
  let firstVariantImageMobile = document.querySelector('#productMediaMobile [data-attached-to-first-variant]');
  let firstVariantImageGrid = document.querySelector('product-media-grid [data-attached-to-first-variant]');
  let firstVariantImageThumbnailsDesktop = document.querySelector('#productMediaDesktop [data-media-thumbnails] [data-attached-to-first-variant]');
  let firstVariantImageThumbnailsMobile = document.querySelector('#productMediaMobile [data-media-thumbnails] [data-attached-to-first-variant]');

  if (firstVariantImageDesktop) {
    let newVariantAttribute = 'data-variant-image-' + event.variant.id;
    let newVariantImageUrl = firstVariantImageDesktop.getAttribute(newVariantAttribute);
    if (newVariantImageUrl) {
      firstVariantImageDesktop.href = newVariantImageUrl;
      firstVariantImageDesktop.querySelector('img').src = newVariantImageUrl;
    }
  }

  if (firstVariantImageMobile) {
    let newVariantAttribute = 'data-variant-image-' + event.variant.id;
    let newVariantImageUrl = firstVariantImageMobile.getAttribute(newVariantAttribute);
    if (newVariantImageUrl) {
      firstVariantImageMobile.href = newVariantImageUrl;
      firstVariantImageMobile.querySelector('img').src = newVariantImageUrl;
    }
  }

  if (firstVariantImageGrid) {
    let newVariantAttribute = 'data-variant-image-' + event.variant.id;
    let newVariantImageUrl = firstVariantImageGrid.getAttribute(newVariantAttribute);
    if (newVariantImageUrl) {
      firstVariantImageGrid.href = newVariantImageUrl;
      firstVariantImageGrid.querySelector('img').src = newVariantImageUrl;
    }
  }

  if (firstVariantImageThumbnailsDesktop) {
    let newVariantAttribute = 'data-variant-image-' + event.variant.id;
    let newVariantImageUrl = firstVariantImageThumbnailsDesktop.getAttribute(newVariantAttribute);
    if (newVariantImageUrl) {
      firstVariantImageThumbnailsDesktop.querySelector('img').srcset = '';
      firstVariantImageThumbnailsDesktop.querySelector('img').src = newVariantImageUrl;
    }
  }

  if (firstVariantImageThumbnailsMobile) {
    let newVariantAttribute = 'data-variant-image-' + event.variant.id;
    let newVariantImageUrl = firstVariantImageThumbnailsMobile.getAttribute(newVariantAttribute);
    if (newVariantImageUrl) {
      firstVariantImageThumbnailsMobile.querySelector('img').srcset = '';
      firstVariantImageThumbnailsMobile.querySelector('img').src = newVariantImageUrl;
    }
  }
});

/* Where the whole card is the link, the card is the hover target: the search
   panel's Popular tiles stretch the title link over the card, which covers the
   image, so a picture-only trigger never fired and the videos stayed blank
   (Sebo, 2026-10-18: "Chrome seems to hover but the others don't" -- Chrome's
   second media is a photo, the others' are videos). */
const WHOLE_CARD = '[data-predictive-search-empty-state] product-card';

function getHoverScope(target) {
  const card = target.closest && target.closest(WHOLE_CARD);
  if (card) return card;
  return target.closest && target.closest('product-card .grid-view-item-image .grid__image');
}

function getVideoFromTarget(e) {
  const scope = getHoverScope(e.target);
  if (!scope) return null;
  return scope.querySelector('.grid__image video');
}

function startVideo(e) {
  const video = getVideoFromTarget(e);
  if (video) video.play().catch(() => {});
}

function stopVideo(e) {
  const video = getVideoFromTarget(e);
  if (!video) return;
  // moving between parts of the same card is not leaving it
  const scope = getHoverScope(e.target);
  if (e.relatedTarget && scope.contains(e.relatedTarget)) return;
  video.pause();
}

document.addEventListener('mouseover', startVideo);
document.addEventListener('mouseout', stopVideo);
document.addEventListener('focusin', (e) => { if (e.target.closest(WHOLE_CARD)) startVideo(e); });
document.addEventListener('focusout', (e) => { if (e.target.closest(WHOLE_CARD)) stopVideo(e); });

/* Feature videos — blocks/gl_feature_videos.liquid.
   The dialog behaviour GLDS § Overlays asks for and the replaced payload had
   none of: a real dialog role, focus moved in and returned to the trigger,
   focus trapped while open, Escape, and the scrim closing it.

   The video src is read from the button, not from a map keyed on the visible
   label. The old version matched on textContent, so renaming a label in the
   theme editor silently served the wrong video with no error anywhere. */
(function () {
  var triggers = document.querySelectorAll('[data-gl-featvid-open]');
  if (!triggers.length) return;

  var lastFocused = null;

  function dialogFor(el) { return el.closest('.gl-featvid, .gl-featvid__dialog') ? document.querySelector('.gl-featvid__dialog') : null; }

  function focusables(dialog) {
    return Array.prototype.filter.call(
      dialog.querySelectorAll('button, [href], video, [tabindex]:not([tabindex="-1"])'),
      function (el) { return el.offsetParent !== null || el.tagName === 'VIDEO'; }
    );
  }

  function open(trigger) {
    var dialog = document.querySelector('.gl-featvid__dialog');
    if (!dialog) return;
    var video = dialog.querySelector('.gl-featvid__video');
    var title = dialog.querySelector('.gl-featvid__title');

    lastFocused = trigger;
    title.textContent = trigger.getAttribute('data-gl-featvid-label') || '';
    video.src = trigger.getAttribute('data-gl-featvid-src');
    dialog.hidden = false;
    document.documentElement.classList.add('gl-featvid-open');

    var close = dialog.querySelector('.gl-featvid__close');
    if (close) close.focus();

    var play = video.play();
    if (play && play.catch) play.catch(function () { /* autoplay refused; controls are there */ });
  }

  function close() {
    var dialog = document.querySelector('.gl-featvid__dialog');
    if (!dialog || dialog.hidden) return;
    var video = dialog.querySelector('.gl-featvid__video');

    video.pause();
    video.removeAttribute('src');
    video.load();
    dialog.hidden = true;
    document.documentElement.classList.remove('gl-featvid-open');

    if (lastFocused) { lastFocused.focus(); lastFocused = null; }
  }

  Array.prototype.forEach.call(triggers, function (t) {
    t.addEventListener('click', function () { open(t); });
  });

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-gl-featvid-close]')) close();
  });

  document.addEventListener('keydown', function (e) {
    var dialog = document.querySelector('.gl-featvid__dialog');
    if (!dialog || dialog.hidden) return;

    if (e.key === 'Escape') { close(); return; }

    if (e.key === 'Tab') {
      var items = focusables(dialog);
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
})();


/* Hero slideshow: stop auto-advancing for anyone who asked for less motion.

   The slideshow auto-advances every 7s (slide_transition_delay), with
   pauseOnMouseEnter false, disableOnInteraction false and no pause control
   anywhere in the section. That is WCAG 2.2.2 Pause, Stop, Hide: content that
   moves for more than five seconds has to be pausable. Twelve of the theme's
   other stylesheets carry prefers-reduced-motion rules; the slideshow has none.

   CSS cannot reach this — the movement is a JS timer, not an animation — so it
   has to be done on the instance. Swiper exposes .autoplay.stop(). The listener
   means a viewer who changes the OS setting with the tab open is honoured too,
   in both directions. */
(function () {
  var mq;
  try { mq = window.matchMedia('(prefers-reduced-motion: reduce)'); } catch (e) { return; }
  if (!mq) return;

  function swipers() {
    return Array.prototype.map.call(
      document.querySelectorAll('.swiper'), function (el) { return el.swiper; }
    ).filter(function (s) { return s && s.autoplay; });
  }

  function apply() {
    swipers().forEach(function (s) {
      if (mq.matches) { s.autoplay.stop(); }
      else if (s.params.autoplay && s.params.autoplay.enabled) { s.autoplay.start(); }
    });
  }

  /* Swiper initialises from deferred modules, so the instances may not exist
     yet at DOMContentLoaded. Poll briefly rather than racing it. */
  var tries = 0;
  (function wait() {
    if (swipers().length || tries++ > 40) { apply(); return; }
    setTimeout(wait, 100);
  })();

  if (mq.addEventListener) { mq.addEventListener('change', apply); }
  else if (mq.addListener) { mq.addListener(apply); }
})();

/* Testimonials carousel — progressive enhancement over CSS scroll-snap.

   The row already scrolls and snaps with no JavaScript: trackpad, touch,
   shift-wheel and keyboard all work from the CSS alone. This only adds arrows,
   so if it never runs the section is still usable rather than broken. Not
   Swiper: the theme's copies are all module-scoped, there is no window.Swiper,
   and a library for five short quotes would be disproportionate on a page that
   already runs two carousels. */
(function () {
  /* Two kinds of scroll row use this, so it is a LIST of tracks rather than a
     testimonials-only lookup. Generalised 2026-08-28 when gl-cards gained a
     scroll row: the arrows already existed and building a second set would have
     been the fourth idiom the repo keeps warning about. */
  var tracks = [];
  Array.prototype.forEach.call(
    document.querySelectorAll('[data-wetheme-section-type="text--testimonials"] .testimonials-block'),
    function (t) { tracks.push({ track: t, what: 'reviews' }); });
  Array.prototype.forEach.call(
    document.querySelectorAll('.gl-cards__list--scroll'),
    function (t) { tracks.push({ track: t, what: 'cards' }); });
  /* An article's "Shop the look" row. It always scrolled, but on desktop exactly
     three cards fit, the scrollbar is hidden and nothing peeks in, so a fourth
     product read as missing. Sebo, 2026-10-02, Murrey Red: "Looks like we're
     truncating the carousel." The arrows show only when the row overflows. */
  Array.prototype.forEach.call(
    document.querySelectorAll('.gl-article__shop'),
    function (t) { tracks.push({ track: t, what: 'products' }); });
  if (!tracks.length) return;

  tracks.forEach(function (entry) {
    var track = entry.track;
    if (!track || track.children.length < 2) return;
    var section = track.closest('.shopify-section') || track.parentNode;

    section.classList.add('gl-revcar');

    /* Nothing to page through if they all fit. Checked after layout, and again
       on resize, because the breakpoint changes how many are visible. */
    function overflowing() { return track.scrollWidth - track.clientWidth > 4; }

    var nav = document.createElement('div');
    nav.className = 'gl-revcar__nav';
    nav.innerHTML =
      '<button class="gl-revcar__btn" type="button" data-dir="-1" aria-label="Previous ' + entry.what + '">' +
        '<svg viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M12.5 4L6.5 10l6 6" ' +
        'stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
      '</button>' +
      '<button class="gl-revcar__btn" type="button" data-dir="1" aria-label="More ' + entry.what + '">' +
        '<svg viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M7.5 4l6 6-6 6" ' +
        'stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
      '</button>';
    track.parentNode.insertBefore(nav, track.nextSibling);

    var prev = nav.children[0], next = nav.children[1];
    var reduce = false;
    try { reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

    function step() {
      var first = track.children[0];
      return first ? first.getBoundingClientRect().width + 32 : track.clientWidth;
    }

    function sync() {
      var can = overflowing();
      nav.style.display = can ? '' : 'none';
      var atStart = track.scrollLeft <= 2;
      var atEnd = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
      prev.disabled = atStart;
      next.disabled = atEnd;
      /* The edge fade follows the SAME state as the arrows, so the gradient is
         only ever on a side that can actually scroll. Class toggles rather than
         inline styles: the mask lives in the stylesheet, where its 56px stays a
         literal — see the invariant-12 note beside the product-grid mask. */
      track.classList.toggle('glScrollCanPrev', can && !atStart);
      track.classList.toggle('glScrollCanNext', can && !atEnd);
    }

    nav.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-dir]');
      if (!btn) return;
      track.scrollBy({ left: step() * Number(btn.dataset.dir),
                       behavior: reduce ? 'auto' : 'smooth' });
    });

    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  });
})();
